import ErrorToastIcon from "../../assets/svgs/common/error-toast.svg";
import InfoToastIcon from "../../assets/svgs/common/info-toast.svg";
import SuccessToastIcon from "../../assets/svgs/common/success-toast.svg";
import { useToast } from "../../hooks/use-toast";
import { Toast, ToastClose, ToastProvider, ToastViewport } from "./toast";

export function Toaster() {
	const { toasts } = useToast();

	const isBrandDash = window.location.pathname.startsWith("/brands");

	return (
		<ToastProvider >
			{toasts.map(({ id, content, toastType, ...props }) => {
				if (toastType === "error") {
					return (
						<Toast
							className={`flex justify-between items-center px-4 py-2 font-semibold ${isBrandDash ? "text-soloprimary backdrop-blur-lg bg-white bg-opacity-90" : "text-primary"}`}
							key={id}
							{...props}
						>
							<div className="flex items-center gap-2">
								<ErrorToastIcon />
								<span>{content}</span>
							</div>
							<ToastClose />
						</Toast>
					);
				}
				if (toastType === "success") {
					return (
						<Toast
							className={`flex justify-between items-center px-4 py-2 font-semibold ${isBrandDash ? "text-soloprimary backdrop-blur-lg bg-white bg-opacity-90" : "text-primary"}`}
							key={id}
							{...props}
						>
							<div className="flex items-center gap-2">
								<SuccessToastIcon />
								<span>{content}</span>
							</div>
							<ToastClose />
						</Toast>
					);
				}
				if (toastType === "info") {
					return (
						<Toast
							className={`flex justify-between items-center px-4 py-2 font-semibold ${isBrandDash ? "text-soloprimary backdrop-blur-lg bg-white bg-opacity-90" : "text-primary"}`}
							key={id}
							{...props}
						>
							<div className="flex items-center gap-2">
								<InfoToastIcon />
								<span>{content}</span>
							</div>
							<ToastClose />
						</Toast>
					);
				}
				return null;
			})}
			<ToastViewport />
		</ToastProvider>
	);
}
